export interface Annotation {
  id: string;
  selectedText: string;
  comment: string;
  colorIndex: number;
}

export interface AnnotationData {
  selectedText: string;
  comment: string;
}

export interface AnnotatableContainerProps {
  children: React.ReactNode;
  onAnnotationsChange?: (annotations: AnnotationData[]) => void;
  sidebarWidth?: number;
  className?: string;
  style?: React.CSSProperties;
}

export interface AnnotatableContainerHandle {
  getAnnotations: () => AnnotationData[];
  clearAnnotations: () => void;
}

export const HIGHLIGHT_COLORS = [
  { bg: 'rgba(255, 213, 79, 0.35)', border: '#FFD54F', sidebar: '#FFF8E1' },
  { bg: 'rgba(129, 199, 132, 0.3)', border: '#81C784', sidebar: '#E8F5E9' },
  { bg: 'rgba(100, 181, 246, 0.3)', border: '#64B5F6', sidebar: '#E3F2FD' },
  { bg: 'rgba(239, 154, 154, 0.3)', border: '#EF9A9A', sidebar: '#FFEBEE' },
  { bg: 'rgba(186, 104, 200, 0.3)', border: '#BA68C8', sidebar: '#F3E5F5' },
  { bg: 'rgba(255, 183, 77, 0.3)', border: '#FFB74D', sidebar: '#FFF3E0' },
];
